import { deepMerge } from "@mittwald/flow-lib/dist/object/deepMerge";
import { deepEqual } from "fast-equals";
import { useState } from "react";
// see https://react-hook-form.com/get-started#Applyvalidation
const reactHooksFormValidationRules = [
    "min",
    "max",
    "minLength",
    "maxLength",
    "pattern",
];
export const updateFieldErrorParams = (existingParams, path, newParam) => {
    const mergeInObject = {
        [path]: newParam,
    };
    if (!existingParams) {
        return mergeInObject;
    }
    const merged = deepMerge(existingParams, mergeInObject);
    if (deepEqual(merged, existingParams)) {
        return existingParams;
    }
    return merged;
};
/**
 * This hooks holds params for field errors, i.e. to be used in translations of
 * validation messages.
 */
export const useFieldErrorParams = () => {
    const [params, setParams] = useState();
    const controller = {
        params,
        update: (path, params) => {
            setParams((existingParams) => updateFieldErrorParams(existingParams, path, params));
        },
        mergeInFields: (fields) => {
            for (const [fieldName, field] of Object.entries(fields)) {
                if (!field) {
                    continue;
                }
                const addRules = (field, fieldName) => {
                    for (const rule of reactHooksFormValidationRules) {
                        const ruleValue = field._f[rule];
                        if (ruleValue && typeof ruleValue !== "object") {
                            controller.update(fieldName, {
                                [rule]: ruleValue,
                            });
                        }
                    }
                };
                if (!("_f" in field)) {
                    for (const [, nestedField] of Object.entries(field)) {
                        if (typeof nestedField === "object" && "_f" in nestedField) {
                            addRules(nestedField, nestedField._f.name);
                        }
                    }
                    continue;
                }
                addRules(field, fieldName);
            }
        },
    };
    return controller;
};
export default useFieldErrorParams;
//# sourceMappingURL=data:application/json;base64,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